const VIEWPORT_MARGIN = 8;
const TRIGGER_GAP = 8;

// Key member popups (project manager, build owner, location contact, project contact) sit
// inside `.key-member-display`, which is a 60px tall scroll container: `overflow-x: auto`
// paired with `overflow-y: hidden` makes it clip on BOTH axes, so an absolutely positioned
// popup gets cut down to a sliver. Those popups switch to `position: fixed` instead, which
// is not clipped by an ancestor's overflow, and take their coordinates from the trigger.
//
// popupHeight may be null when the popup sizes to its content: the popup is then always
// placed below the trigger, since there is no height to test the viewport against.
export default function overflowSafePopupPosition(triggerElement, popupWidth, popupHeight) {
  if (!triggerElement || !triggerElement.getBoundingClientRect) {
    return null;
  }
  const rect = triggerElement.getBoundingClientRect();

  let top = rect.bottom + TRIGGER_GAP;
  let flipped = false;
  if (popupHeight && top + popupHeight + VIEWPORT_MARGIN > window.innerHeight) {
    const above = rect.top - popupHeight - TRIGGER_GAP;
    if (above >= VIEWPORT_MARGIN) {
      top = above;
      flipped = true;
    }
    else {
      top = Math.max(VIEWPORT_MARGIN, window.innerHeight - popupHeight - VIEWPORT_MARGIN);
    }
  }

  // Centre the popup on the trigger. Both popups draw their arrow at the box's centre
  // (.avatar-info__box uses left: 46% on a 20px wide arrow, so its point lands at ~128px of
  // 256px; .multi-user-popup__triangle uses calc(50% - 4px) on an 8px one), so centring the
  // box lines the arrow up with the trigger too.
  const maxLeft = Math.max(VIEWPORT_MARGIN, window.innerWidth - popupWidth - VIEWPORT_MARGIN);
  const left = Math.min(Math.max(rect.left + (rect.width / 2) - (popupWidth / 2), VIEWPORT_MARGIN), maxLeft);

  return { top, left, flipped };
}



// WEBPACK FOOTER //
// ./src/helpers/popupPositioning.js